import React, { useState } from "react";
import axios from "axios";
import ProfileSearch from "./ProfileSearch";
import ConfirmProfiles from "./ConfirmProfiles";
import toast from "react-hot-toast";

const PROFILE_STEP = "profiles";
const CONFIRM_STEP = "confirm";

export default function AddForm({
  scoringResultId,
  organizationId,
  fetchData,
}) {
  const [loading, setLoading] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [activeStep, setActiveStep] = useState(PROFILE_STEP);

  function onCreate() {
    if (!scoringResultId || !organizationId) {
      toast.error("This evaluation has no scoring result yet.");
      return;
    }

    setLoading(true);

    axios
      .post(`/scoring-results/${scoringResultId}/run-clearscreen-calculation/`, {
        organization_id: organizationId,
        occupational_profile_ids: profiles.map((p) => p.id),
      })
      .then(() => setLoading(false))
      .then(() => fetchData())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <div className="segment">
      {activeStep === PROFILE_STEP && (
        <ProfileSearch
          profiles={profiles}
          onSubmit={(pros) => {
            setActiveStep(CONFIRM_STEP);
            setProfiles(pros);
          }}
        />
      )}
      {activeStep === CONFIRM_STEP && (
        <ConfirmProfiles
          profiles={profiles}
          onBackClick={() => setActiveStep(PROFILE_STEP)}
          onSubmit={onCreate}
          loading={loading}
        />
      )}
    </div>
  );
}
